import { FLOATING_ELEMENT_PLACEMENT } from '../../../constants/common'
import { FloatingSelectDropdown } from '../../Floating'
import { useCalendarGridCardTrigger } from '../CalendarGrid.hooks'

function CalendarGridCardTrigger({
  Trigger,
  placement = FLOATING_ELEMENT_PLACEMENT.rightStart,
  renderContent,
  triggerProps,
}) {
  const {
    context,
    floatingStyles,
    getFloatingProps,
    getReferenceProps,
    handleClose,
    isOpen,
    refs,
  } = useCalendarGridCardTrigger({ placement })

  return (
    <>
      <Trigger
        {...getReferenceProps(triggerProps)}
        elementRef={refs.setReference}
      />
      <FloatingSelectDropdown
        context={context}
        floatingStyles={floatingStyles}
        getFloatingProps={getFloatingProps}
        isOpen={isOpen}
        refs={refs}
      >
        {renderContent({ onClose: handleClose })}
      </FloatingSelectDropdown>
    </>
  )
}

export default CalendarGridCardTrigger
